import { Component, inject, OnInit } from '@angular/core';
import { MaintenanceService } from '../../services/maintenance.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'oops-page',
  templateUrl: './oops-page.component.html',
  styleUrls: ['./oops-page.component.scss'],
  imports: [DatePipe]
})
export class OopsPageComponent implements OnInit {
  private maintenanceService = inject(MaintenanceService);

  get maintenanceEndTime(): Date { return this.maintenanceService.maintenanceEndTime; }

  ngOnInit(): void {
  }

}
